import { render } from "./PanelGroup.vue?vue&type=template&id=4903e77a&scoped=true&ts=true"
import script from "./PanelGroup.vue?vue&type=script&lang=ts"
export * from "./PanelGroup.vue?vue&type=script&lang=ts"

import "./PanelGroup.vue?vue&type=style&index=0&id=4903e77a&lang=scss&scoped=true"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4903e77a"]])

export default __exports__